import React from "react";
import "@/app/pages/contactProfile/styles/ContactProfileOverviewStyles.scss"

const BottomGrayBanner = () => (
  <div className="component-wrapper bg-color-gray-background">
    <div className="container">
      <div className="row spacing-mt-20 spacing-mb-20 spacing-sm-p-16">
        <div className="col-md-2"></div>
        <div className="col-md-8">
          <div className="colPar0 parsys">
            <div className="content_text RootBaseComponent section">
              <div className="zc08db5dc3129427785fed94cda90b7fb">
                <div className="z_7efa428bb8d23d1d_contenttext jbIqMOv_M8MaLY998mhh">
                  <p className="heading-5 text-center">If you would like to update or remove your profile from the Dun &amp; Bradstreet Contact Directory, please <a title="contact us" className="anchor" href="https://support.dnb.com/?PROD=ContactDirectory" target="_blank">contact us</a>.
                  </p>
                </div>
              </div>
              {/* <script>window["___DMK_AEM_SIX_FIVE___"]["contentText"]({"data":{"textRewritten":"\u003cp class\u003d\"heading-5\" style\u003d\"text-align: center;\"\u003eIf you would like to update or remove your profile from the Dun \u0026amp; Bradstreet Contact Directory, please \u003ca title\u003d\"contact us\" href\u003d\"https://support.dnb.com/?PROD\u003dContactDirectory\" target\u003d\"_blank\"\u003econtact us\u003c/a\u003e.\u003c/p\u003e\r\n"},"identifier":"zc08db5dc3129427785fed94cda90b7fb"});</script> */}
            </div>

          </div>
        </div>
        <div className="col-md-2"></div>
      </div>
    </div>
    <div className="clear"></div>
  </div>
)

export default BottomGrayBanner